var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 33.177H4.37496C2.97496 33.177 1.82288 32.025 1.82288 30.625V11.6666C1.82288 5.22079 5.22079 1.82288 11.6666 1.82288H23.3333C29.7791 1.82288 33.177 5.22079 33.177 11.6666V23.3333C33.177 29.7791 29.7791 33.177 23.3333 33.177ZM11.6666 4.01038C6.44579 4.01038 4.01038 6.44579 4.01038 11.6666V30.625C4.01038 30.8291 4.17079 30.9895 4.37496 30.9895H23.3333C28.5541 30.9895 30.9895 28.5541 30.9895 23.3333V11.6666C30.9895 6.44579 28.5541 4.01038 23.3333 4.01038H11.6666Z",
    fill: "url(#paint0_linear_274_7611)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6042 18.5938H12.3959C11.798 18.5938 11.3021 18.0979 11.3021 17.5C11.3021 16.9021 11.798 16.4062 12.3959 16.4062H22.6042C23.2021 16.4062 23.698 16.9021 23.698 17.5C23.698 18.0979 23.2021 18.5938 22.6042 18.5938Z",
    fill: "url(#paint1_linear_274_7611)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.698C16.9021 23.698 16.4062 23.2021 16.4062 22.6042V12.3959C16.4062 11.798 16.9021 11.3021 17.5 11.3021C18.0979 11.3021 18.5938 11.798 18.5938 12.3959V22.6042C18.5938 23.2021 18.0979 23.698 17.5 23.698Z",
    fill: "url(#paint2_linear_274_7611)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_274_7611",
    x1: 1.82288,
    y1: 16.0069,
    x2: 33.177,
    y2: 16.0069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_274_7611",
    x1: 11.3021,
    y1: 17.3958,
    x2: 23.698,
    y2: 17.3958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_274_7611",
    x1: 16.4062,
    y1: 16.9098,
    x2: 18.5937,
    y2: 16.9098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.674a84273104e55ee2194a31bf722f8f.svg";
export { ForwardRef as ReactComponent };